<template>
  <sdui-card
    v-if="canDisplayCard"
    class="mt-1 mb-3 w-100"
    :title="$t('global.user_status.muted.hint.title')"
    :description="$t('global.user_status.muted.hint.description', { view: header })"
    :button-text="$t('global.user_status.muted.hint.button_text')"
    :background-gradient="false"
    button-classes="bg-white btn-light btn-shadow"
    :data-cy="`notifications-banner-${$route.name}`"
    :button-cy-data="`notifications-banner-button-${$route.name}`"
    is-navigational-action
    @action="navigateToNotificationSettings()"
    @close="rememberClosedState()"
  />
</template>

<script>
import SduiCard from 'src/components/miscellaneous/ui/cards/SduiCard.vue'

export default {
  name: 'NotificationsMutedForView',
  components: { SduiCard },
  computed: {
    routeName() {
      return this.$router.currentRoute.value.name
    },

    canDisplayCard() {
      return !!localStorage?.getItem(this.localStorageKey)
    },

    header() {
      return this.$t(this.$route.meta.headerText)
    },

    localStorageKey() {
      if (this.routeName === 'feed') return 'users.notifications.news.push.show.muted.hint'
      if (this.routeName === 'channels') return 'users.notifications.channels.push.show.muted.hint'
      if (['timetable', 'course-details'].includes(this.routeName)) return 'users.notifications.timetables.push.show.muted.hint'
      if (['calendar-grid', 'calendar-list'].includes(this.routeName)) return 'users.notifications.calendar.push.show.muted.hint'
      return null
    },
  },

  methods: {
    navigateToNotificationSettings() {
      if (!this.$me) return
      this.$router.push({ name: 'settings-notifications-general', params: { id: this.$me.id } })
    },

    async rememberClosedState() {
      localStorage?.removeItem(this.localStorageKey)
    },
  },
}
</script>
